'use strict';

angular.module('ntmApp').factory('TopBar', ['BreadCrumbs', 'DailyPlanService', 'EmergencyService', 'DailyPlanConfirmationService', 'Constants', 'Utils', 'FlashService', 'CommonHelper',
    function (BreadCrumbs, DailyPlanService, EmergencyService, DailyPlanConfirmationService, Constants, Utils, FlashService, CommonHelper) {

    function TopBar(context) {

        var self = this;

        var dateCycle = null;
        var onDateChangingEvent = null;
        var onDateChangedEvent = null;
        var holidays = [];
        var emergency = [];
        
        self.initTopBar = function (topBarInfo) {
            self.minimumActivityScheduleDate = null;
            self.maximumActivityScheduleDate = topBarInfo.maxScheduleDate;
            dateCycle = topBarInfo.dateCycle;
            self.BreadCrumbs.setViewTypes(topBarInfo.units);
            self.BreadCrumbs.onViewTypeChanged(function () {
                applyHolidayInfo();
            });
            self.activityStatuses = topBarInfo.activityStatuses;
            self.aplicationIcon = topBarInfo.aplicationIcon;
            holidays = topBarInfo.holidays;
            emergency = topBarInfo.emergency;
            applyHolidayInfo();

            self.applicationOptButtons = topBarInfo.applicationOptButtons.map(function (button) {
                if (button.jsonProperties) {
                    button.jsonProperties = JSON.parse(button.jsonProperties);
                }

                return button;
            });

            initTopBarBreadCrumbs();
        };

        self.isCurrentDateDisplayed = function () {
            return moment(self.todayDate).isSame(moment(self.dateDisplayed), 'days');
        };

        self.isMinDateDisplayed = function () {
            return self.minimumActivityScheduleDate && moment(self.minimumActivityScheduleDate).isValid() ? moment(self.minimumActivityScheduleDate).isSame(moment(self.dateDisplayed), 'days') : false;
        };

        self.isMaxDateDisplayed = function () {
            return moment(self.maximumActivityScheduleDate).isSame(moment(self.dateDisplayed), 'days');
        };

        self.isPastDateDisplayed = function () {
            return moment(self.dateDisplayed).isBefore(moment(self.todayDate), 'days');
        };

        self.isFutureDateDisplayed = function () {
            return moment(self.dateDisplayed).isAfter(moment(self.todayDate), 'days');
        };

        self.onDateChangedViaCalendar = function () {

            var dateChanged = function () {

                if (onDateChangingEvent) {
                    onDateChangingEvent(onDateChangedEvent);
                }

                sessionStorage.currentDate = self.dateDisplayed;

                setWeeklyCycleWeekNumberChar(self.dateDisplayed);

                applyHolidayInfo();
            };

            if (self.hasEmergencyChanges()) {
                self.confirmViewLeaving(dateChanged);
            } else {
                dateChanged();
            }
        };

        self.changeDate = function (type) {

            var perfromChangeDate = function () {
                var dateChanged = function () {
                    var date = new Date(self.dateDisplayed);
                    switch (type) {
                        case ('prev'):
                            date.setDate(self.dateDisplayed.getDate() - 1);
                            break;
                        case ('next'):
                            date.setDate(self.dateDisplayed.getDate() + 1);
                            break;
                        case ('today'):
                            date = new Date(self.todayDate);
                            break;
                    }

                    self.dateDisplayed = sessionStorage.currentDate = date;
                    setWeeklyCycleWeekNumberChar(self.dateDisplayed);

                    if (onDateChangedEvent) {
                        onDateChangedEvent();
                    }

                    applyHolidayInfo();
                };

                if (self.hasEmergencyChanges()) {
                    self.confirmViewLeaving(dateChanged);
                } else {
                    dateChanged();
                }
            };

            if (onDateChangingEvent) {
                onDateChangingEvent(perfromChangeDate);
            } else {
                perfromChangeDate();
            }
        };

        self.onDateChanged = function (event) {
            onDateChangedEvent = event;
        };

        self.onDateChanging = function (event) {
            onDateChangingEvent = event;
        };

        self.setUnplanetActivityDefaults = function (data, button) {
            if (!button.jsonProperties) {
                return data;
            }

            data.model = {};
            button.jsonProperties.defaults.forEach(function (item) {
                if (item.currentDate) {
                    data.model[item.currentDate] = self.dateDisplayed;
                }

                if (!Utils.IsNull(self.BreadCrumbs.selectedLocation.id)) {
                    if (item.facilityArea) {
                        data.model[item.facilityArea] = self.BreadCrumbs.selectedLocation.name;
                    }

                    if (item.facilityAreaCode) {
                      data.model[item.facilityAreaCode] = self.BreadCrumbs.selectedLocation.id;
                    }

                    if (self.BreadCrumbs.selectedLocation.type === 0) {
                        if (item.areaCode) {
                            data.model[item.areaCode] = self.BreadCrumbs.selectedLocation.id;
                        }
                        if (item.areaName) {
                            data.model[item.areaName] = self.BreadCrumbs.selectedLocation.name;
                        }
                        if (item.groupName) {
                            data.model[item.groupName] = 'Area';
                        }
                    } else if (self.BreadCrumbs.selectedLocation.type === 1) {
                        if (item.facilityCode) {
                            data.model[item.facilityCode] = self.BreadCrumbs.selectedLocation.id;
                        }
                        if (item.facilityName) {
                            data.model[item.facilityName] = self.BreadCrumbs.selectedLocation.name;
                        }
                        if (item.groupName) {
                            data.model[item.groupName] = 'Facility';
                        }
                    }
                }

                if (self.BreadCrumbs.selectedRoom.roomNumber && item.roomNumber) {
                    data.model[item.roomNumber] = self.BreadCrumbs.selectedRoom.roomNumber;
                }
				
				if (self.BreadCrumbs.selectedRoom.roomDetails && item.rackFlag) {
				    data.model[item.rackFlag] = self.BreadCrumbs.selectedRoom.roomDetails.rackCensusFlag ? true : false;
                }
            });

            return data;
        };

        self.openAppOptionBtnPage = function (button) {

            var data = {
                button: button,
                setDefaults: self.setUnplanetActivityDefaults,
                onDataUpdatedMethod: function () {
                    onDateChangedEvent();
                }
            };

            Utils.OpenModal('', 'ng1/src/dailyPlan/views/dialogs/appOptionsBtnDialog.html', 'AppOptionsBtnController', data, 'setup-open-modal-dialog daily-plan-cancelled-activities-dialog', null, false);
        };

        self.closeEmergency = function () {
            if (self.hasEmergencyChanges()) {
                self.confirmViewLeaving(self.BreadCrumbs.closeEmergency);
            } else {
                self.BreadCrumbs.closeEmergency();
            }
        };

        self.applyEmergency = function (redirect) {

            var request = {
                unitId: self.BreadCrumbs.selectedViewType.id,
                date: self.dateDisplayed,
                checkedSchedules: EmergencyService.getCheckedActivities(),
                adHocActivities: EmergencyService.getAdHocActivities()
            };

            var loading = FlashService.Loading();

            EmergencyService.ApplyChanges(request).then(function (result) {
                EmergencyService.updateViewAfterSave();
                emergency.push(result.data.data);
                if (onDateChangedEvent) {
                    onDateChangedEvent();
                }
                applyHolidayInfo();
                loading.dismiss();
                FlashService.Success(result.data.message);
                if (redirect) {
                    redirect();
                }
            });
        };

        self.cancelEmergency = function () {
            EmergencyService.CancelChanges();
        };

        self.deactivateEmergency = function () {
            var request = {
                unitId: self.BreadCrumbs.selectedViewType.id,
                date: self.dateDisplayed,
                emergencyId: self.holidayEmergencyData.emergency.id
            };

            var loading = FlashService.Loading();

            EmergencyService.Deactivate(request).then(function (result) {
                EmergencyService.clearAll();
                EmergencyService.updateViewAfterSave();
                emergency = emergency.filter(e => e.id !== self.holidayEmergencyData.emergency.id);
                if (onDateChangedEvent) {
                    onDateChangedEvent();
                }
                applyHolidayInfo();
                loading.dismiss();
                FlashService.Success(result.data.message);
            });

        };

        self.confirmViewLeaving = function (nextAction) {

            var saveAndContinue = function () {
                self.applyEmergency(nextAction);
            };

            var continueWithoutSaving = function () {
                EmergencyService.CancelChanges();
                nextAction();
            };

            DailyPlanConfirmationService.Confirmation('Apply emergency?')
                               .Yes(saveAndContinue)
                               .No(continueWithoutSaving)
                               .Ask();
        };

        self.hasEmergencyChanges = function () {
            return EmergencyService.HasChanges();
        };

        function setWeeklyCycleWeekNumberChar(date) {
            self.weeklyCycleWeekNumberChar = CommonHelper.Dates.GetWeeklyCycleWeekNumberChar(date, dateCycle);
        }

        function applyHolidayInfo() {
            self.holidayEmergencyData = {
                emergency: emergency.filter(e => moment(self.dateDisplayed).isSame(e.date, 'days') && e.unitId === self.BreadCrumbs.selectedViewType.id)[0],
                holiday: holidays.filter(h => moment(self.dateDisplayed).isBetween(h.dateFrom, h.dateTo || h.dateFrom, 'days', '[]'))[0]
            };

            self.holidayEmergencyData.label = self.holidayEmergencyData.emergency ? '{0} SCHEDULE'.format(self.holidayEmergencyData.holiday ? 'HOLIDAY' : 'EMERGENCY') : null;
        }

        function initTopBarBreadCrumbs() {

            setWeeklyCycleWeekNumberChar(self.dateDisplayed);

            switch (self.BreadCrumbs.getCurrentLevel()) {
                case Constants.DailyPlanLevels.LEVEL1:
                    self.BreadCrumbs.changeViewType(self.BreadCrumbs.selectedViewType);
                    break;
                case Constants.DailyPlanLevels.LEVEL2:
                    var request = context.getViewModeAndSelectedDate();

                    DailyPlanService.GetBreadcrumb(request).then(function (result) {
                        self.BreadCrumbs.setLocations(result.data);

                        if (!Utils.IsNull(self.BreadCrumbs.selectedLocation.id)) {
                            self.BreadCrumbs.changeLocation(self.BreadCrumbs.selectedLocation);
                        }
                    });
                    break;
                case Constants.DailyPlanLevels.LEVEL3:

                    var locationBreadCrumbsRequest = context.getViewModeAndSelectedDate();

                    DailyPlanService.GetBreadcrumb(locationBreadCrumbsRequest).then(function (result) {
                        self.BreadCrumbs.setLocations(result.data);

                        var roomBreadCrumbsRequest = context.getViewModeSelectedDateAndLocation();

                        DailyPlanService.GetRoomBreadcrumb(roomBreadCrumbsRequest).then(function (response) {
                            self.BreadCrumbs.setRooms(response.data.roomBreadcrumbs);

                            if (self.BreadCrumbs.selectedRoom.roomNumber) {
                                self.BreadCrumbs.changeRoom(self.BreadCrumbs.selectedRoom);
                            }
                        });
                    });
                    break;
                default:
                    break;
            }
        }

        function initialize() {
            self.todayDate = new Date();
            self.dateDisplayed = sessionStorage.currentDate ? new Date(sessionStorage.currentDate) : new Date();
            self.BreadCrumbs = new BreadCrumbs();
        }

        initialize();
    }

    return (TopBar);

}]);
